import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { noteAdminVisit } from '@/lib/auth';

export default function Layout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  // Reaching an /admin route means the visitor passed Cloudflare Access, so
  // remember this is the owner's browser — that's what enables the identity
  // probe (and edit/favourite affordances) on public pages.
  useEffect(() => {
    if (isAdmin) noteAdminVisit();
  }, [isAdmin]);

  // Public screens (home / recipe / favourites) manage their own layout — the
  // mobile-app top bar and full-bleed hero need full width. Admin screens keep
  // a centered, padded container.
  return (
    <div className="min-h-screen">
      {isAdmin ? (
        <main className="mx-auto w-full max-w-content px-4 py-6 pb-24">
          <Outlet />
        </main>
      ) : (
        // Unstyled, so public screens keep their full-bleed layout.
        <main>
          <Outlet />
        </main>
      )}
    </div>
  );
}
